export const accountsTypes = [
  {
    name: 'Gmail',
    icon: require('../images/accounts-icons/gmail-icon.svg'),
    shortName: 'gmail',
    displayNameProp: 'email',
  },
  {
    name: 'Google Drive',
    icon: require('../images/accounts-icons/google-drive-icon.svg'),
    shortName: 'gdrive',
    displayNameProp: 'email',
  },
  {
    name: 'Slack',
    icon: require('../images/accounts-icons/slack-icon.svg'),
    shortName: 'slack',
    displayNameProp: 'team_name',
  },
  /*{
    name: 'Outlook',
    icon: require('../images/accounts-icons/outlook-icon.svg'),
    shortName: 'outlook',
    displayNameProp: 'email',
  },*/
  {
    name: 'Dropbox',
    icon: require('../images/accounts-icons/dropbox-icon.svg'),
    shortName: 'dropbox',
    displayNameProp: 'email',
  },
  {
    name: 'JIRA',
    icon: require('../images/accounts-icons/jira-icon.svg'),
    shortName: 'jira',
    displayNameProp: 'email',
  },

  {
    name: 'Office 365',
    icon: require('../images/accounts-icons/microsoft-365.svg'),
    shortName: 'office-365',
    displayNameProp: 'email'
  }, {
    name: 'Microsoft Teams',
    icon: require('../images/accounts-icons/teams.svg'),
    shortName: 'teams',
    displayNameProp: 'email'
  },
  /*{
    name: 'Onedrive',
    icon: require('../images/accounts-icons/one-drive.svg'),
    shortName: 'onedrive',
    displayNameProp: 'email'
  },*/
  {
    name: 'Google Calendar',
    icon: require('../images/accounts-icons/google-calendar.svg'),
    shortName: 'gcalendar',
  },
  {
    name: 'GitHub',
    icon: require('../images/accounts-icons/github.svg'),
    shortName: 'github',
  },
  {
    name: 'Trello',
    icon: require('../images/accounts-icons/trello.svg'),
    shortName: 'trello',
  },
  {
    name: 'Box',
    icon: require('../images/accounts-icons/box.svg'),
    shortName: 'box',
  },
  {
    name: 'AWS',
    icon: require('../images/accounts-icons/aws.svg'),
    shortName: 'aws',
  },
  {
    name: 'Asana',
    icon: require('../images/accounts-icons/asana.svg'),
    shortName: 'asana',
  },
  {
    name: 'Salesforce',
    icon: require('../images/accounts-icons/salesforce.svg'),
    shortName: 'salesforce',
  },
  {
    name: 'Azure',
    icon: require('../images/accounts-icons/azure.svg'),
    shortName: 'azure',
  },
  {
    name: 'Azure DevOps',
    icon: require('../images/accounts-icons/devops.svg'),
    shortName: 'azuredevops',
  },
  {
    name: 'Confluence',
    icon: require('../images/accounts-icons/confluence.svg'),
    shortName: 'confluence',
  },
  {
    name: 'Figma',
    icon: require('../images/accounts-icons/figma.svg'),
    shortName: 'figma',
  },
  {
    name: 'Notion',
    icon: require('../images/accounts-icons/notion.svg'),
    shortName: 'notion',
  },
  {
    name: 'Miro',
    icon: require('../images/accounts-icons/miro.svg'),
    shortName: 'miro',
  },
  {
    name: 'Evernote',
    icon: require('../images/accounts-icons/evernote.svg'),
    shortName: 'evernote',
  },
  {
    name: 'Bitbucket',
    icon: require('../images/accounts-icons/bitbucket.svg'),
    shortName: 'bitbucket',
  },
  {
    name: 'Discord',
    icon: require('../images/accounts-icons/discord.svg'),
    shortName: 'discord',
  },
  {
    name: 'HubSpot',
    icon: require('../images/accounts-icons/hubspot.svg'),
    shortName: 'hubspot',
  },
  {
    name: 'GitLab',
    icon: require('../images/accounts-icons/gitlab.svg'),
    shortName: 'gitlab',
  },
  {
    name: 'Monday',
    icon: require('../images/accounts-icons/monday.svg'),
    shortName: 'moday',
  },
  {
    name: 'Todoist',
    icon: require('../images/accounts-icons/todoist.svg'),
    shortName: 'todoist',
  },
  {
    name: 'Whatsapp',
    icon: require('../images/accounts-icons/whatsapp.svg'),
    state: 'Coming Soon',
    shortName: 'whatsapp',
  },
  {
    name: 'Wechat',
    icon: require('../images/accounts-icons/wechat.svg'),
    state: 'Coming Soon',
    shortName: 'wechat',
  },
  {
    name: 'iMessage',
    icon: require('../images/accounts-icons/iMessage.svg'),
    state: 'Coming Soon',
    shortName: 'imessage',
  },
  {
    name: 'Skype',
    icon: require('../images/accounts-icons/skype.svg'),
    state: 'Coming Soon',
    shortName: 'skype',
  },
]